import { render, staticRenderFns } from "./ClientsFollowUp.vue?vue&type=template&id=559c1f59&"
import script from "./ClientsFollowUp.vue?vue&type=script&lang=js&"
export * from "./ClientsFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports